import { Component } from '@angular/core'

@Component({
	selector: 'ReportsLayout',
	template: `
      <router-outlet></router-outlet>
  `
})

export class ReportsLayoutComponent { }
